// extracted by mini-css-extract-plugin
export default {"form":"commentForm_form__Ux6c+","footer":"commentForm_footer__15y0r"};